export default __webpack_public_path__ + "5187a9aa6b5bbbdcbbdbcbebaa445fc2.png";